import { useMutation } from "@tanstack/react-query";
import { endpoints } from "utils/endpoints";
import api from "utils/api";
import {
  ICirculationSettings,
  IEmailSettings,
  IFineSettings,
  IGeneralSettings,
  IHolidaySettings,
  IMemberCardSettings,
  IReminderSettings,
} from "./types";

export function DeleteLibrary() {
  return useMutation({
    mutationFn: (id: string | number) =>
      api.get<number>(`${endpoints.library.delete}/${id}`),
  });
}

export function AddLibrary() {
  return useMutation({
    mutationFn: (model: IGeneralSettings) =>
      api.post<number>(endpoints.library.addLibrary, model),
  });
}

export function UpdateGeneralSettings() {
  return useMutation({
    mutationFn: (model: IGeneralSettings) =>
      api.post<number>(endpoints.library.updateGeneralSettings, model),
  });
}

export function UpdateCirculationSettings() {
  return useMutation({
    mutationFn: (model: ICirculationSettings) =>
      api.post<number>(endpoints.library.updateCirculationSettings, model),
  });
}

export function UpdateFineSettings() {
  return useMutation({
    mutationFn: (model: IFineSettings) =>
      api.post<number>(endpoints.library.updateFineSettings, model),
  });
}

export function UpdateHolidaySettings() {
  return useMutation({
    mutationFn: (model: IHolidaySettings) =>
      api.post<number>(endpoints.library.updateHolidaySettings, model),
  });
}

export function UpdateEmailSettings() {
  return useMutation({
    mutationFn: (model: IEmailSettings) =>
      api.post<number>(endpoints.library.updateEmailSettings, model),
  });
}
export function UpdateReminderSettings() {
  return useMutation({
    mutationFn: (model: IReminderSettings) =>
      api.post<number>(endpoints.library.updateReminderSettings, model),
  });
}

export function UpdateMemberCardSettings() {
  return useMutation({
    mutationFn: (model: IMemberCardSettings) =>
      api.post<number>(endpoints.library.updateMemberCardSettings, model),
  });
}

